import inputData from './inputData/client-referral-form';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'client-referral-form',
  title: 'Client Referral Form',
  description: 'Make it easy for happy clients to recommend your business by collecting referrals from friends and colleagues.',
  image: '/images/templates/client-referral-form.png',
  tags: ['customer-success', 'make-sales'],
  inputData: inputData,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

